/**
 * Prepare message data for react-json-view:
 * - Convert bigints to strings (JSON-incompatible)
 */
export function sanitizeForJsonView(obj: unknown): Record<string, unknown> {
  function walk(value: unknown): unknown {
    if (typeof value === "bigint") {
      return value.toString();
    } else if (Array.isArray(value)) {
      return value.map((item) => walk(item));
    } else if (value !== null && typeof value === "object") {
      const out: Record<string, unknown> = {};
      for (const [k, v] of Object.entries(value)) {
        out[k] = walk(v);
      }
      return out;
    }
    return value;
  }

  return walk(obj) as Record<string, unknown>;
}
